import { useUserActiveOrganization, useOutboundSubscriptions } from "@/api";
import { outboundSubscriptionColumns } from "../../assets/SubscriptionColumns";
import { useOutboundSubscriptionTableData } from "../../hooks/useSubscriptionTableData";
import { SubscriptionsTable } from "./SubscriptionsTable";

interface Props {
  filterInactive: boolean;
}

const OutboundSubscriptionTable = ({ filterInactive }: Props) => {
  const { activeOrganization } = useUserActiveOrganization();
  const { data, loading, error } = useOutboundSubscriptions({
    organizationSlug: activeOrganization?.slug
  });
  const tableData = useOutboundSubscriptionTableData(data, filterInactive);

  return (
    <SubscriptionsTable
      data={tableData}
      loading={loading}
      error={error}
      columns={outboundSubscriptionColumns}
    />
  );
};

export default OutboundSubscriptionTable;
